import { render } from "./clientSection.vue?vue&type=template&id=200b9616&scoped=true"
import script from "./clientSection.vue?vue&type=script&lang=js"
export * from "./clientSection.vue?vue&type=script&lang=js"

import "./clientSection.vue?vue&type=style&index=0&id=200b9616&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200b9616"]])

export default __exports__